export default {
  text_one: 'Guadagna {{count}} punto',
  text_other: 'Guadagna {{count}} punti',
};
